module.exports = __webpack_public_path__ + "static/media/investpic1.7114c14c.png";